import { ExternalLink } from "lucide-react";

// gid://shopify/Order/1234567890 -> "1234567890" (null when there is no numeric id).
export const orderNumericId = (gid) => (/(\d+)\s*$/.exec(String(gid || "")) || [])[1] || null;

// The store's handle in admin.shopify.com links (owner-confirmed, fixed). It is NOT the API domain
// (fe0npq-g8.myshopify.com, which Shopify passes as ?shop=), so it is never derived from ?shop= or an env value.
// Same constant as backend shop.ADMIN_STORE_HANDLE.
export const ADMIN_STORE_HANDLE = "zero-ducks-given";

export const adminOrderUrl = (id) => `https://admin.shopify.com/store/${ADMIN_STORE_HANDLE}/orders/${id}`;

// Inside the admin iframe App Bridge handles the shopify:// deep link on the top frame; standalone: a new tab.
export const openOrderInShopify = (id) => {
  if (window.shopify) window.open(`shopify://admin/orders/${id}`, "_top");
  else window.open(adminOrderUrl(id), "_blank", "noopener,noreferrer");
};

export const OpenInShopifyButton = ({ gid, name }) => {
  const id = orderNumericId(gid);
  if (!id) return null;
  const label = `Open order #${String(name || id).replace(/^#/, "")} in Shopify`;
  return (
    <button
      type="button"
      data-testid={`order-open-shopify-${id}`}
      aria-label={label}
      title={label}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        openOrderInShopify(id);
      }}
      className="inline-flex items-center justify-center gap-1.5 h-8 w-8 sm:w-auto sm:px-3 rounded-full border border-border bg-background text-foreground text-xs font-semibold whitespace-nowrap hover:bg-muted transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <ExternalLink className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span className="hidden sm:inline">Open in Shopify</span>
    </button>
  );
};
